import { BbitI18n, BbitLanguage, bbitProdEnvironmentKey } from '@bbitgmbh/bbit.utils';
import { BbitWebShopService, webShopTranslations } from '@bbitgmbh/webshop.sdk';
import { BbitStructuredDataService, BbitWebsiteService } from '@bbitgmbh/website.sdk';
import { translations } from './translations';

export function appFactory(
  _webshop: BbitWebShopService,
  website: BbitWebsiteService,
  structuredData: BbitStructuredDataService,
) {
  return async () => {
    BbitI18n.setDefaultLanguage(BbitLanguage.DE_CH);
    BbitI18n.setDefaultTimezone('Europe/Zurich');
    BbitI18n.addTranslations(webShopTranslations);
    BbitI18n.addTranslations(translations);

    await Promise.all([
      website.initialize({
        organizationKey: 'bt',
        environmentKey: 'prod',
        authConfigKey: 'booking-prod',
        // devBlApiUrl: window.location.hostname === 'localhost' ? 'http://localhost:4301' : undefined,
      }),

      // routes.initialize({
      //   languages: [BbitLanguage.DE_CH, BbitLanguage.FR_CH],
      //   defaultLanguage: BbitLanguage.DE_CH,
      // }),
    ]);

    const identity = website.getAuthMeta()?.environments?.[bbitProdEnvironmentKey]?.identity;
    structuredData.initialize({
      name: identity?.fullName || '',
      url: 'https://booking.bt-ag.ch',
      phone: identity?.mainPhone || '',
      eMail: identity?.mainEMail || '',
    });
  };
}
